import React, {useState, useEffect} from 'react';

function ClientViewPageSettingsStartGame() {
    const [startSetting, setStartSetting] = useState(null)

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    const handleStartSettingChange = async () => {
        const response = await window.pywebview.api.change_start_setting();

        if (response.status === "success") {
            setStartSetting(response["value"])
        } else {
            showAlert("error", response.message)
        }
    }

    useEffect(() => {
        async function fetchStartSetting() {
            const start_setting = await window.pywebview.api.get_start_setting();
            setStartSetting(start_setting)
        }

        fetchStartSetting()
    }, [])

    return (
        <>
            <div className="flex flex-col gap-4 md:gap-0 md:flex-row items-center justify-between p-4 bg-[#101922] border border-[#324d67] rounded-lg">
                <div>
                    <p className="text-white font-medium">Start Game</p>
                    <p className="text-[#92adc9] text-xs">Start ACC at launch.</p>
                </div>

                <input className='w-[20px] h-[20px]' type="checkbox" checked={startSetting} onChange={(e) => handleStartSettingChange(e)}/>
            </div>

            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[35px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default ClientViewPageSettingsStartGame;